var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "user-questionnaire-form-container w-100 user-modal-register-view px-2",
      style: _vm.containerStyle,
    },
    [
      [
        _c(
          "div",
          { staticClass: "w-100 mb-4" },
          [
            _c("div", { staticClass: "mb-2 text-center" }, [
              _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
                _vm._v(_vm._s(_vm._f("trans")("Tell us about yourself"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2 text-center py-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("trans")(
                      "And we'll personalize your experience for %project%!",
                      { "%project%": _vm.projectName }
                    )
                  ) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("DotNavigation"),
            _vm._v(" "),
            _c("div", { staticClass: "text-center py-2 mb-2" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("Tell us more about your work environment")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.isStatusDone
              ? _c("div", [
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.industryValue,
                            expression: "industryValue",
                          },
                        ],
                        staticClass: "w-100 p-2 br-4 border bg-white",
                        attrs: {
                          name: "industry",
                          id: "industry",
                          disabled: _vm.isSubmitting,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.industryValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Industry"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Construction and architecture" } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "Construction and architecture"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Education" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Education"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Financial services" } },
                          [
                            _vm._v(
                              _vm._s(_vm._f("trans")("Financial services"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Government and non-profit" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("Government and non-profit")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Healthcare" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Healthcare"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Information technology" } },
                          [
                            _vm._v(
                              _vm._s(_vm._f("trans")("Information technology"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Law and Legal" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Law and Legal"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Management consulting" } },
                          [
                            _vm._v(
                              _vm._s(_vm._f("trans")("Management consulting"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: {
                              value: "Marketing, communication and design",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "Marketing, communication and design"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Real estate" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Real estate"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Sports" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Sports"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: {
                              value: "Wholesale, logistics, and retail",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "Wholesale, logistics, and retail"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "other" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Other (Freeform)"))),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.industryValue === "other"
                    ? _c(
                        "div",
                        { staticClass: "mx-auto p-0 mb-4" },
                        [
                          _c("TextArea", {
                            attrs: {
                              name: "form",
                              type: "text",
                              label: _vm.getPlaceholder,
                              "max-characters": 180,
                              disabled: _vm.isSubmitting,
                            },
                            model: {
                              value: _vm.industryFreefieldValue,
                              callback: function ($$v) {
                                _vm.industryFreefieldValue = $$v
                              },
                              expression: "industryFreefieldValue",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.departmentValue,
                            expression: "departmentValue",
                          },
                        ],
                        staticClass: "w-100 p-2 br-4 border bg-white",
                        attrs: {
                          name: "department",
                          id: "department",
                          disabled: _vm.isSubmitting,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.departmentValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Department"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Administration" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Administration"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Design" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Design"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Finance" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Finance"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Legal" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Legal"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Marketing" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Marketing"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Operations" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Operations"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Sales" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Sales"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Teacher/Coach" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Teacher/Coach"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "other" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Other (Free form)"))),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.departmentValue === "other"
                    ? _c(
                        "div",
                        { staticClass: "mx-auto p-0 mb-4" },
                        [
                          _c("TextArea", {
                            attrs: {
                              name: "form",
                              type: "text",
                              label: _vm.getPlaceholder,
                              "max-characters": 180,
                              disabled: _vm.isSubmitting,
                            },
                            model: {
                              value: _vm.departmentFreefieldValue,
                              callback: function ($$v) {
                                _vm.departmentFreefieldValue = $$v
                              },
                              expression: "departmentFreefieldValue",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-5" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companySizeValue,
                            expression: "companySizeValue",
                          },
                        ],
                        staticClass: "w-100 p-2 br-4 border bg-white",
                        attrs: {
                          name: "company_size",
                          id: "company_size",
                          disabled: _vm.isSubmitting,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.companySizeValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Company size"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Just me" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("Just me"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "2-20 employees" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("2-20 employees"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "20-100 employees" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("20-100 employees"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "20-500 employees" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("20-500 employees"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "500+ employees" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("500+ employees"))),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm.isStatusLoading
              ? _c("LoadingAnimation", {
                  attrs: { "animation-style": "bars", classes: "mb-4" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("ButtonWithLoadingState", {
                  staticClass:
                    "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
                  attrs: {
                    "data-user-modal-button-submit": "",
                    text: _vm._f("trans")("Done"),
                    "is-state-loading": _vm.isSubmitting,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.saveProfile.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-lg",
                  attrs: { disabled: _vm.isSubmitting },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onBackButtonClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("trans")("Back")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }